/**
 * Open issues persistently linked to a single workflow — the same
 * `GET /workflows/open-issues` batch endpoint the flow list uses for its "N
 * issues" chip, called here with a single id for the flow designer / run
 * detail surfaces (e.g. `FailureDiagnosticSection`'s multi-issue links).
 *
 * @module hooks/useWorkflowOpenIssues
 */
import { useQuery } from '@tanstack/react-query';
import { fetchFlowListOpenIssues } from '../ui/pages/flow-list/api';
import type { OpenWorkflowIssueSummary } from '../ui/pages/flow-list/types';

export function useWorkflowOpenIssues(workflowId: string | null | undefined) {
  return useQuery<OpenWorkflowIssueSummary[]>({
    queryKey: ['workflow-open-issues', workflowId],
    enabled: Boolean(workflowId),
    queryFn: async () => {
      if (!workflowId) return [];
      const issuesByWorkflow = await fetchFlowListOpenIssues([workflowId]);
      return issuesByWorkflow[workflowId] ?? [];
    },
  });
}
